import { CardType } from '@core/enums/card/card-type.enum';
import { CardValidityType } from '@core/enums/card/card-validity-type.enum';
import { ICardDate } from '@core/interfaces/card/card-date.interface';
import { ICardDenomination } from '@core/interfaces/card/card-denomination.interface';
import { ICardItem } from '@core/interfaces/card/card-item-interface';
import { ICardValidity } from '@core/interfaces/card/card-validity.interface';
import { AAGUID } from '@interticket/core';
import { DateTime } from 'luxon';

export class CardItem implements ICardItem {

  readonly id: AAGUID;
  readonly name: string;
  readonly shortDescription: string;
  readonly imageId: string;
  readonly cardType: CardType;
  readonly validity: ICardValidity;
  readonly visibility: ICardDate;
  readonly onSale: ICardDate;
  readonly denominations: ICardDenomination[];

  readonly isBuyable: boolean;

  constructor(iCardItem: ICardItem) {
    this.id = iCardItem.id;
    this.name = iCardItem.name;
    this.shortDescription = iCardItem.shortDescription;
    this.imageId = iCardItem.imageId;
    this.cardType = iCardItem.cardType;
    this.validity = iCardItem.validity;
    this.visibility = iCardItem.visibility;
    this.onSale = iCardItem.onSale;
    this.denominations = iCardItem.denominations;

    this.isBuyable = this.initIsBuyable();
  }

  private initIsBuyable(): boolean {
    const now = DateTime.local();
    const isValidityNotExpired = this.validity.type !== CardValidityType.FROM_TO || DateTime.fromISO(this.validity.to) > now;
    const isOnSale = this.onSale.enabled && DateTime.fromISO(this.onSale.from) < now &&
      (!this.onSale.to || DateTime.fromISO(this.onSale.to) > now);

    return isValidityNotExpired && isOnSale;
  }

}
